export default __webpack_public_path__ + "assets/salon-de-nuit-moderne-quebec.149580a3.webp";